import React from "react";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import sittingImage from "../images/sitting10.png";
import topimage from "../images/trend-up-grap.png";
import bottomimage from "../images/trend-line-graph.png";
import headerImg from "../images/hero-bg15.jpg";
import { useInView } from "react-intersection-observer";
import { SiTicktick } from "react-icons/si";

const HeroSection = () => {
  const { ref: leftRef, inView: leftInView } = useInView({ triggerOnce: true });
  const { ref: rightRef, inView: rightInView } = useInView({
    triggerOnce: true,
  });

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 4, md: 6, lg: 20, xl: 20 },
        py: { xs: 10, md: 20 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: { xs: 6, md: 6 },
        backgroundImage: ` url(${headerImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        overflow: "hidden",
        opacity: 0.95,
      }}
    >
      {/* Left Content */}
      <Box
        ref={leftRef}
        sx={{
          width: { xs: "100%", md: "50%" },
          textAlign: { xs: "center", md: "left" },
          transform: leftInView ? "translateX(0)" : "translateX(-100px)",
          opacity: leftInView ? 1 : 0,
          transition: "all 1s ease",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: {
              xs: "2.2rem", // ~35px
              sm: "2.5rem", // ~40px
              md: "2.7rem", // ~48px
            },
            fontWeight: 800,
            lineHeight: 1.1,
            fontFamily: "Aeonik-bold, sans-serif", // use Satoshi or SF Pro Display if available
            color: "#111827",
            mb: { xs: 0, sm: 0, md: 0, lg: 5 },
          }}
        >
          <span style={{ color: "#a10304" }}>CEN</span>
          <span style={{ color: "#032262" }}>SOFT</span> is a leading Digital &
          IT solutions provider,
          <br />
          <Box
            component="span"
            sx={{
              color: "#a10304", // Tailwind blue-600
              fontWeight: 800,
            }}
          >
            driving enterprise transformation with agility, efficiency, and
            innovation.
          </Box>
        </Typography>

        <Box
          sx={{
            transform: leftInView ? "translateY(0)" : "translateY(40px)",
            opacity: leftInView ? 1 : 0,
            transition: "all 1.2s ease",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              mb: 3,
              fontFamily: "Aeonik",
		fontWeight: "bold",
              fontSize: { xs: "1rem", md: "1rem" },
            }}
          >
            We deliver cutting-edge digital services across diverse technology
            platforms, enabling large-scale business transformation for
            clients—from Fortune 500 companies to high-growth startups. Our
            expertise empowers businesses to foster innovation, enhance customer
            experiences, and implement transformative digital initiatives.
          </Typography>

          <List
            sx={{
              display: "inline-block",
              textAlign: { xs: "left", md: "left" },
              fontSize: { xs: "1rem", md: "1rem" },
            }}
          >
            {[
              "Foster innovation.",
              "Enhance customer experiences",
              "Implement transformative digital initiatives",
            ].map((text) => (
              <ListItem key={text} disablePadding sx={{ py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <SiTicktick color="primary" fontSize="medium" />
                </ListItemIcon>
		 <Typography
                  component="div" // Important for list item alignment
                  sx={{
                    fontSize: "16px",
                    fontWeight:"bold",
                    fontFamily: "Aeonik , sans-serif",
                    letterSpacing: "0.02em",
                    lineHeight: "1.5",
                    textRendering: "optimizeLegibility",
                    WebkitFontSmoothing: "antialiased",
                    MozOsxFontSmoothing: "grayscale",
                    flex: 1, // Takes remaining space like ListItemText
                    py: "6px", // Match ListItemText padding
                    ml: 2, // Match ListItemText indentation
                  }}
                >
                  {text}
                </Typography>
              </ListItem>
            ))}
          </List>

        {/* <Box
            sx={{
              textAlign: { xs: "center", md: "left" },
              mt: 6,
            }}
          >
            <Button
              variant="contained"
              sx={{
                position: "relative",
                overflow: "hidden",
                backgroundColor: "#032262",
                color: "white",
                px: { xs: 4, md: 6 },
                py: { xs: 1.5, md: 2 },
                fontSize: { xs: "0.85rem", md: "1.2rem" },
                fontFamily: "Aeonik-bold, sans-serif",
                textTransform: "none",
                zIndex: 1,
                "&:before": {
                  content: "''",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "#a10304",
                  transform: "translateY(100%)",
                  transition: "transform 0.3s ease-in-out",
                  zIndex: -1,
                },
                "&:hover:before": {
                  transform: "translateY(0)",
                },
                "&:hover": {
                  color: "white",
                },
              }}
            >
              Book a free consultation
            </Button>
          </Box> */}
        </Box>
      </Box>

      {/* Right Content */}
      <Box
        ref={rightRef}
        sx={{
          width: { xs: "100%", md: "50%" },
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: { xs: 6, md: 0 },
          transform: rightInView ? "translateX(0)" : "translateX(100px)",
          opacity: rightInView ? 1 : 0,
          transition: "all 1s ease",
        }}
      >
        {/* Top Floating Card */}
        {/* <Paper
          elevation={4}
          className="floatTop"
          sx={{
            position: "absolute",
            top: { xs: -10, sm: 10, md: -110 },
            left: { xs: "30%", sm: 20, md: 10, lg: 80, xl: 120 },
            transform: { xs: "translateX(-50%)", md: "none" },
            padding: { xs: 1, sm: 1.5, md: 3 },
            borderRadius: 5,
            backgroundColor: "#fff",
            width: { xs: 140, sm: 180, md: 150, lg: 150, xl: 140 },
            height: { xs: 110, sm: 160, md: 140, lg: 160, xl: 140 },
            zIndex: 3,
            textAlign: "center",
          }}
        >
          <Typography
            variant="caption"
            fontWeight="bold"
            fontSize={{ xs: 10, sm: 12, md: 14 }}
          >
            Average return on <br /> investment by SEO
          </Typography>
          <Typography
            variant="h6"
            color="primary"
            fontWeight="bold"
            fontSize={{ xs: 14, sm: 18, md: 20 }}
          >
            +780%
          </Typography>
          <Box
            component="img"
            src={topimage}
            alt="topimage"
            sx={{
              width: { xs: 80, sm: 150, md: 140, lg: 180, xl: 140 },
              mt: 1,
            }}
          />
        </Paper> */}

        {/* Main Image */}
        <Box
          component="img"
          src={sittingImage}
          alt="Sitting"
          sx={{
            width: { xs: 300, sm: 260, md: 500, lg: 700 },
            height: "auto",
            transform: "scaleX(1)",
            zIndex: 1,
            display: "block",
            objectFit: "contain",
          }}
        />

        {/* Bottom Floating Card */}
        {/* <Paper
          elevation={4}
          className="floatBottom"
          sx={{
            position: "absolute",
            bottom: { xs: 0, sm: 10, md: 20, lg: 20, xl: -100 },
            right: { xs: "30%", sm: 0, md: 0, lg: 20, xl: 30 },
            transform: { xs: "translateX(50%)", md: "none" },
            padding: 1.5,
            borderRadius: 2,
            backgroundColor: "#fff",
            width: { xs: 140, sm: 180, md: 160, lg: 180, xl: 200 },
            height: { xs: 110, sm: 160, md: 160, lg: 180, xl: 200 },
            zIndex: 2,
            textAlign: "center",
          }}
        >
          <Typography
            variant="caption"
            fontWeight="bold"
            fontSize={{ xs: 9, sm: 12, md: 15 }}
          >
            Rankings / Average position
          </Typography>
          <Typography variant="h6" color="primary" fontWeight="bold">
            33
          </Typography>
          <Box
            component="img"
            src={bottomimage}
            alt="Bottom Line"
            sx={{
              width: { xs: 90, sm: 150, md: 110, lg: 150, xl: 180 },
              mt: 1,
            }}
          />
        </Paper> */}
      </Box>

      <style>
        {`
          @keyframes floatTop {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          @keyframes floatBottom {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(10px); }
          }

          .floatTop {
            animation: floatTop 3s ease-in-out infinite;
          }

          .floatBottom {
            animation: floatBottom 3s ease-in-out infinite;
          }

          @media (max-width: 600px) {
            .floatTop, .floatBottom {
              animation: none !important;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default HeroSection;
